export const appShellLayoutSx = {
  minHeight: '100vh',
  bgcolor: 'background.default',
  // Asymmetric, per the frame — see `--app-shell-inset-*` in `scss/index.scss`.
  // Full-height columns inside read `--app-shell-column-height` rather than
  // re-deriving `100vh` minus this padding.
  padding:
    'var(--app-shell-inset-top) var(--app-shell-inset-right)' +
    ' var(--app-shell-inset-bottom) var(--app-shell-inset-left)',
  display: 'flex',
  gap: 0,
  alignItems: 'stretch',
  overflow: 'hidden',
}
